import { useEffect, useRef, memo } from 'react';

function TradingViewWidget() {
  const container = useRef();

  useEffect(() => {
    const loadWidget = () => {
      try {
        if (typeof window.TradingView === 'undefined') {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.src = 'https://s3.tradingview.com/tv.js';
          script.onload = () => initWidget();
          script.onerror = () => {
            console.warn('Failed to load TradingView library');
            if (container.current) {
              container.current.innerHTML = '<div class="flex items-center justify-center h-full text-gray-500">Unable to load chart data</div>';
            }
          };
          document.head.appendChild(script);
        } else {
          initWidget();
        }
      } catch (error) {
        console.warn('Error initializing TradingView widget:', error);
      }
    };

    const initWidget = () => {
      try {
        if (!container.current || !window.TradingView) return;

        // Clear previous content
        container.current.innerHTML = '';

        new window.TradingView.widget({
          "container_id": container.current.id,
          "autosize": true,
          "symbol": "BINANCE:BTCUSDT",
          "interval": "D",
          "timezone": "Etc/UTC",
          "theme": "light",
          "style": "1",
          "locale": "en",
          "toolbar_bg": "#f1f3f6",
          "enable_publishing": false,
          "withdateranges": true,
          "hide_side_toolbar": false,
          "allow_symbol_change": true,
          "details": true,
          "hotlist": true,
          "calendar": true,
          "show_popup_button": true,
          "popup_width": "1000",
          "popup_height": "650",
          "hide_volume": false,
          "hide_drawing_toolbar": false,
          "studies": [
            "RSI@tv-basicstudies",
            "MASimple@tv-basicstudies",
            "MACD@tv-basicstudies"
          ],
          "width": "100%",
          "height": "100%"
        });
      } catch (error) {
        console.warn('Error creating TradingView widget:', error);
      }
    };

    // Generate a unique ID for the container
    const uniqueId = `tradingview_${Math.random().toString(36).substring(7)}`;
    if (container.current) {
      container.current.id = uniqueId;
    }

    loadWidget();

    return () => {
      // Cleanup
      if (container.current) {
        container.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="tradingview-widget-container h-[500px] rounded-lg overflow-hidden border border-gray-200" ref={container}>
      <div className="flex items-center justify-center h-full text-gray-500">
        Loading chart...
      </div>
    </div>
  );
}

export default memo(TradingViewWidget); 